import { i18n } from '@lingui/core';

// Shared by both funnels: the pre-sale one (TransmissionCreateLeadForm) owns the
// first two positions, `EcommerceSchema` owns `document` and `billing`, and
// `done` is a stage screen. Step entries reference these names, so the progress
// bar position is resolved from the schema instead of a hardcoded index.
export const ECOMMERCE_STEP_NAME = {
  PLOT: 'plot',
  CONTACT: 'contact',
  DOCUMENT: 'document',
  BILLING: 'billing',
  DONE: 'done',
} as const;

export const ECOMMERCE_STEPS = [
  { name: ECOMMERCE_STEP_NAME.PLOT, label: i18n.t('Pytania o działkę') },
  { name: ECOMMERCE_STEP_NAME.CONTACT, label: i18n.t('Dane kontaktowe') },
  { name: ECOMMERCE_STEP_NAME.DOCUMENT, label: i18n.t('Wybór dokumentu') },
  { name: ECOMMERCE_STEP_NAME.BILLING, label: i18n.t('Dane do zamówienia') },
  { name: ECOMMERCE_STEP_NAME.DONE, label: i18n.t('Gotowe') },
];
